import { z } from 'zod';

import { planSpecSchema } from './spec';

// One row distilled from a Medplum $validate OperationOutcome. Only
// error/fatal issues are carried — a clean array means every compiled
// resource (the PlanDefinition AND its ActivityDefinitions) is guaranteed
// to insert at save.
export const planValidationIssueSchema = z.object({
  resource: z
    .string()
    .describe(
      "Which compiled resource failed, e.g. 'PlanDefinition' or 'ActivityDefinition/chin-tucks'.",
    ),
  severity: z.string(),
  details: z.string(),
  expression: z.string().nullable(),
});

export type PlanValidationIssue = z.infer<typeof planValidationIssueSchema>;

// The presentPlan tool's output — the living draft the preview pane renders
// and Save stores. Shared between the backend tool and the browser.
export const planDraftSchema = z.object({
  plan: planSpecSchema,
  valid: z
    .boolean()
    .describe('True when Medplum $validate accepted every compiled resource.'),
  issues: z
    .array(planValidationIssueSchema)
    .describe('Validation errors, empty when valid. Fix the spec and re-emit.'),
});

export type PlanDraft = z.infer<typeof planDraftSchema>;
